(() => {
  const init = () => document.querySelectorAll('[data-ix-header-search]').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const input = root.querySelector('input[type="search"]');
    const panel = root.querySelector('.ix-header-search__panel');
    const popular = root.querySelector('.ix-header-search__popular');
    const results = root.querySelector('.ix-header-search__results');
    const all = root.querySelector('.ix-header-search__all');
    let timer;
    let controller;
    let version = 0;
    const close = () => { panel.hidden = true; input.setAttribute('aria-expanded', 'false'); };
    const open = () => { panel.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    const message = text => {
      const p = document.createElement('p');
      p.className = 'ix-header-search__message';
      p.textContent = text;
      results.replaceChildren(p);
    };
    const safeUrl = raw => {
      try { const url = new URL(raw, window.location.origin); return url.origin === window.location.origin ? url.href : null; }
      catch { return null; }
    };
    const load = async (query, currentVersion) => {
      controller = new AbortController();
      const requestController = controller;
      results.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(root.dataset.suggestUrl + '.json', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product,article,page');
        url.searchParams.set('resources[limit]', '4');
        url.searchParams.set('resources[limit_scope]', 'each');
        const response = await fetch(url, { signal: requestController.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (currentVersion !== version) return;
        const resources = data.resources?.results || {};
        const fragment = document.createDocumentFragment();
        let count = 0;
        for (const [type, label] of [['products', root.dataset.productsLabel], ['articles', root.dataset.articlesLabel], ['pages', root.dataset.pagesLabel]]) {
          const items = resources[type] || [];
          if (!items.length) continue;
          const group = document.createElement('div');
          group.className = 'ix-header-search__group';
          const heading = document.createElement('p');
          heading.className = 'ix-header-search__label';
          heading.textContent = label;
          group.append(heading);
          items.forEach(item => {
            const href = safeUrl(item.url);
            if (!href) return;
            const link = document.createElement('a');
            link.className = 'ix-header-search__result';
            link.href = href;
            const imageUrl = typeof item.image === 'string' ? item.image : item.image?.url;
            if (imageUrl && /^https:\/\//.test(imageUrl)) {
              const img = document.createElement('img');
              img.src = imageUrl;
              img.alt = '';
              img.width = 42;
              img.height = 42;
              img.loading = 'lazy';
              link.append(img);
            }
            const title = document.createElement('span');
            title.textContent = item.title;
            link.append(title);
            group.append(link);
            count++;
          });
          fragment.append(group);
        }
        results.replaceChildren(fragment);
        if (!count) message(root.dataset.emptyLabel);
      } catch (error) {
        if (error.name !== 'AbortError' && currentVersion === version) message(root.dataset.errorLabel);
      } finally {
        if (currentVersion === version) results.removeAttribute('aria-busy');
      }
    };
    input.addEventListener('focus', open);
    input.addEventListener('input', () => {
      clearTimeout(timer);
      controller?.abort();
      const currentVersion = ++version;
      const query = input.value.trim();
      results.replaceChildren();
      results.removeAttribute('aria-busy');
      popular.hidden = query.length > 0;
      all.hidden = query.length === 0;
      const url = new URL(root.dataset.searchUrl, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('options[prefix]', 'last');
      all.href = url.href;
      open();
      if (query.length) timer = setTimeout(() => load(query, currentVersion), 220);
    });
    root.addEventListener('keydown', event => {
      if (event.key === 'Escape') { input.focus(); close(); event.preventDefault(); return; }
      if (!['ArrowDown', 'ArrowUp'].includes(event.key) || panel.hidden) return;
      const links = Array.from(panel.querySelectorAll('a')).filter(link => link.getClientRects().length);
      if (!links.length) return;
      const current = links.indexOf(document.activeElement);
      const next = event.key === 'ArrowDown' ? (current + 1) % links.length : (current <= 0 ? links.length - 1 : current - 1);
      links[next].focus();
      event.preventDefault();
    });
    root.addEventListener('focusout', () => setTimeout(() => { if (!root.contains(document.activeElement)) close(); }, 0));
    document.addEventListener('click', event => { if (!root.contains(event.target)) close(); });
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
